import React, { Suspense, lazy, useEffect, useState } from "react";

//Hooks
import { useScrollLock } from "@magento/peregrine";

//Style
import classes from "./main.module.scss";
import SliderFullPage from "../../../../components/SliderFullPage";
import { useUserContext } from "../../../peregrine/context/user";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import { useIntl } from "react-intl";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import MyAccountOffcanvas from "../../../../components/MyAccount/Offcanvas/myAccountOffCanvas";
import { GET_CUSTOMER } from "@overrides_venia/peregrine/talons/SignIn/signIn.gql";
import { useAwaitQuery } from "@magento/peregrine/lib/hooks/useAwaitQuery";
import { Offcanvas } from "@Components/Offcanvas/offcanvas";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import CreateAccountPage from "../../../../components/CreateAccountPage";
import { ModalCompleteCustomerData } from "@Components/ModalCompleteCustomerData/modalCompleteCustomerData";
import { useSentry } from "@Src_main/utils/useSentry";
import { useMutation } from "@apollo/client";
import { UPDATECUSTOMERV2 } from "@Src_main/pages/MyAccountData/customerInfo.js";
import { useExponea } from "@Src_main/utils/useExponea";

//Components
var Footer = lazy(() => import("../Footer"));
var Header = lazy(() => import("../Header/header"));
var Login = lazy(() => import("../../../../components/Login"));
var ForgotPassword = lazy(() => import("../ForgotPassword"));
var CookieBanner = lazy(() => import("../../../../components/CookieBanner/cookieBanner"));
var Main = props => {
  var {
    children,
    isMasked
  } = props;
  var history = useHistory();
  var {
    trackEvent
  } = useExponea();
  useSentry();
  var {
    isMobile
  } = useWindowSize();
  var [isModalCompleteCustomerDataOpen, setIsModalCompleteCustomerDataOpen] = useState(false);
  var [handleUpdateCustomer] = useMutation(UPDATECUSTOMERV2);
  useScrollLock(isMasked);
  var [{
    currentUser,
    isUserComplete,
    isSignedIn,
    isSignedInOnSessionStart,
    hasUserMandatoryFields,
    hasUserOptionalFields,
    isApp
  }, {
    getUserDetails
  }] = useUserContext();
  var location = useLocation();
  var {
    formatMessage
  } = useIntl();
  var fetchUserDetails = useAwaitQuery(GET_CUSTOMER);

  // request data from server
  useEffect(() => {
    if (isSignedIn) getUserDetails({
      fetchUserDetails
    });
  }, [fetchUserDetails, getUserDetails, isSignedIn]);
  useEffect(() => {
    if (currentUser && currentUser.email) {
      exponea.identify({
        account_id: currentUser.email,
        email: currentUser.email
      });
      trackEvent("customer_logged");
      if (isSignedIn && (hasUserMandatoryFields === false || hasUserOptionalFields === false) && isSignedInOnSessionStart === false && !location.pathname.includes(formatMessage({
        id: "url.key.loyalty.data"
      }))) {
        setIsModalCompleteCustomerDataOpen(true);
      }
    }
  }, [currentUser]);
  useEffect(() => {
    window.isSignedIn = isSignedIn;
    if (isSignedIn === false && isApp) {
      history.replace(formatMessage({
        id: "url.key.app.login"
      }));
    }
    return () => {
      delete window.isSignedIn;
    };
  }, [isSignedIn]);
  var showOffcanvasRegistration = !location.pathname.includes(formatMessage({
    id: "url.key.signup"
  }));
  var showOffcanvasLogin = !location.pathname.includes(formatMessage({
    id: "url.key.login"
  }));
  var loyaltyOffcanvases = currentUser.email && isSignedIn ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-my-account",
    classes: classes
  }, /*#__PURE__*/React.createElement(MyAccountOffcanvas, {
    range_seeds: "500"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, showOffcanvasLogin ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-login-dx",
    classes: classes
  }, /*#__PURE__*/React.createElement(Login, null)) : null, showOffcanvasRegistration ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-registration-dx",
    className: classes.offcanvasRegistration,
    classes: classes,
    overflowHidden: !isMobile
  }, isMobile ? /*#__PURE__*/React.createElement(CreateAccountPage, {
    showHeader: true
  }) : /*#__PURE__*/React.createElement("div", {
    className: "uk-flex"
  }, /*#__PURE__*/React.createElement(CreateAccountPage, {
    showHeader: false
  }))) : null, /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-pwdforgot-dx",
    classes: classes
  }, /*#__PURE__*/React.createElement(ForgotPassword, null)));
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement("main", {
    className: classes.root
  }, isOrderActive && isMobile ? null : /*#__PURE__*/React.createElement(Header, null), loyaltyOffcanvases, /*#__PURE__*/React.createElement("div", {
    className: classes.pageSize
  }, children), isOrderActive && isMobile ? null : /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(CookieBanner, null), isSignedIn ? /*#__PURE__*/React.createElement(ModalCompleteCustomerData, {
    isOpen: isModalCompleteCustomerDataOpen,
    setIsOpen: setIsModalCompleteCustomerDataOpen
  }) : null));
};
export default Main;